import {Model} from '@vuex-orm/core';

export class Figure extends Model {
  static entity = 'figures';

  static fields() {
    return {
      id: this.attr(null),
      path: this.attr(''),
    };
  }

  id: number;
  path: string;
}
